import axios from 'axios'

const API = axios.create({
    baseURL: (process.env.NODE_ENV == "development") ? 'https://api.dev.pagespy.io/v1' : 'https://api.pagespy.io/v1',
    timeout: 5000,
    headers: {
        'Token': localStorage.getItem("APIToken")
    }
});

API.interceptors.response.use(null, function(error) {
    console.log(error);

    if (error.status != 200) {
        App.$toasted.error('Could not fetch resource.').goAway(3000)
    }

    return Promise.reject(error);
});

API.monitors = {
    getAll() {
        return API.get(`/monitors`).then(response => {
            return response.data.monitors;
        })
    },
    findByID(id) {
        console.log("api/monitors.findByID", id)
        return API.get(`/monitors/${id}`).then(response => {
            return response.data
        }).catch(function(e){
            App.$toasted.error(e)
        })
    },
    Update(monitor) {
        return API.put(`/monitors/${monitor.id}`, monitor).then(response => {
            return response;
        })
    },
    // if there's a monitor ID just update the existing monitor, else just save a new
    // one
    Save(monitor) {
        if(monitor.id) {
            return API.put(`/monitors/${monitor.id}`, monitor)
        } else {
            return API.post(`/monitors`, monitor)
        }
    },
    Start(monitor) {
      return API.post(`/monitors/${monitor.id}/start`).then(response => {
        return response;
      })
    },
    Pause(monitor) {
      return API.post(`/monitors/${monitor.id}/pause`).then(response => {
        return response;
      })
    },
    Spy(id) {
      return API.post(`/monitors/${id}/check`).then(response => {
        return response;
      })
    }
}

API.notificators = {
    findByID(id) {},
    Update(notificator) {
        return API.put(`/notificators/${notificator.id}`, notificator).then(response => {
            return response.data;
        })
		},
    Save(notificator) {
        return API.post(`/notificators`, notificator).then(response => {
            return response.data;
        })
    }
}

// I need a way to retrieve the token from the user's localStorage (or maybe go for JWT at one point)

export default API



// WEBPACK FOOTER //
// ./src/api/index.js